import { render, staticRenderFns } from "./TepBloqueIndex.vue?vue&type=template&id=5e274148"
import script from "./TepBloqueIndex.vue?vue&type=script&lang=js"
export * from "./TepBloqueIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports